module.exports = __webpack_public_path__ + "img/help_banner@3x.1aba8a52.png";